import styled from "styled-components";
import { getRiskColorByNameAndSelect } from "../../utils";

export interface RiskBoxProps {
  color?: string;
  size?: string;
  facilities?: boolean;
  active?: boolean;
}

export const RiskBoxFilterStatus = styled.div.attrs({ "data-testid": "risk-box" }) <RiskBoxProps>`
  width: ${({ size }) => (size === "small" ? "12" : "24")}px;
  height: ${({ size }) => (size === "small" ? "12" : "24")}px;
  border-radius: 50%;
  box-sizing: border-box;
  outline: none;
  user-select: none;
  margin-right: ${({ size }) => (size === "small" ? "0.5" : "0.75")}rem;
  background-color: ${({ color, active }) => getRiskColorByNameAndSelect(active, color)};
  cursor: pointer;
`;

export const InfoIcon = styled.div`
  cursor: pointer;
  align-self: center;
  padding-left: 4px;
  font-size: 9px;

  h4 {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
  }

  h5 {
    font-size: 12px;
    line-height: 16px;
  }

  .tooltip {
    max-width: 170px;
  }
`;
